import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import { Navigate } from 'react-router';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import { useFalabellaAccess } from '@/hooks/useFalabellaAccess';
import usePageTitle from '@/hooks/usePageTitle';
import FalabellaSection from '@/sections/plugins/Falabella';

const FalabellaPage = () => {
  usePageTitle('Integraciones - Falabella');
  const hooks = useFalabellaAccess();

  if (!hooks.checked) {
    return (
      <Container maxWidth="xxl">
        <SectionTitle title="Falabella" mt={5}>
          <LocalShippingOutlinedIcon fontSize="large" />
        </SectionTitle>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!hooks.hasFalabellaAccess) {
    return <Navigate to="/my-plugins" replace />;
  }

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Falabella" mt={5}>
        <LocalShippingOutlinedIcon fontSize="large" />
      </SectionTitle>

      <FalabellaSection />
    </Container>
  );
};

export default FalabellaPage;
